import mutations from "@/store/mutations/cookieDataMutation";
import getters from "@/store/getters/cookieDataGetter";
/**
 * [GX] Cookie DATA
 */
export default {
  state: {
    cookieData: []
  },
  mutations,
  getters
  // actions
};
